module.exports = __webpack_public_path__ + "img/pr.593e4150.svg";